import './services/firebaseApp'

import { StyleProvider, ReactQuery, I18NProvider } from '@codeleap/common'
import { Settings, variantProvider, React, I18N } from './app'
import { DebugModal, GlobalAlert, GlobalStyle, Onboarding, ShareModal, variants } from './components'
import { Provider } from 'react-redux'
import { store } from './redux'
import { APIClient } from './services'

const App = ({ children }) => {
  APIClient.Session.useSession(false)

  return (
    <>
      <GlobalStyle />
      {children}
      <GlobalAlert />
      <DebugModal />
      <Onboarding />
      <ShareModal />
    </>
  )
}

export const Root = ({ children }) => {
  return (
    <ReactQuery.QueryClientProvider client={APIClient.queryClient.client}>
      <Provider store={store}>
        <StyleProvider
          settings={Settings}
          variantProvider={variantProvider}
          variants={variants}
          logger={logger}
        >
          <I18NProvider i18n={I18N}>
            <App>
              {children}
            </App>
          </I18NProvider>
        </StyleProvider>
      </Provider>
    </ReactQuery.QueryClientProvider>
  )
}
